import React from "react";
import ApiIntegrationComponent from '../component/Api-Integration/api-integration'
import ErrorBoundary from "./ErrorBoundary";

const ApiIntegration = () => {
  return <div>
    <ErrorBoundary>
        <ApiIntegrationComponent />
    </ErrorBoundary>
  </div>;
};

export default ApiIntegration;
